export function getAemModel(container) {
    const stringifiedModel = container.dataset.desAppModel || "";
    try {
        return JSON.parse(stringifiedModel);
    }
    catch (e) {
        console.error(e);
        return {};
    }
}
//# sourceMappingURL=getAemModel.js.map